<template lang="html">
  <li @click="selectAddress()" tabindex="0">
    <span>{{ addressData.name }}</span><br>
    <span class="small-text">{{ (addressData.comune) ? addressData.code + ', ' + addressData.comune : (addressData.type) ? addressData.type : '' }}</span>
  </li>
</template>

<script>
export default {
  props: {
    addressData: {
      required: true,
    }
  },
  methods: {
    selectAddress() {
      var options = {
        name: this.addressData.name,
        type: this.addressData.type,
        tagId: this.addressData.tagId,
        placeId: this.addressData.placeId,
        lat: this.addressData.lat,
        lng: this.addressData.lng,
        href: this.addressData.href,
      };
      this.$emit('addressSelected', options);
  	},
  }
}
</script>

<style lang="css" scoped>
  li {
    padding: 10px 0px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
</style>
